import Box from '@mui/material/Box';
import { FC } from 'react';

const FormField: FC = ({ children }) => <Box>{children}</Box>;

export { FormField };
